import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Button, TextField } from '@material-ui/core';

import { FileInput } from './components';

const useStyles = makeStyles(theme => ({
    root: {}
}));

const Field = props => {
    const { className, data, sendData } = props;

    const [value, setValue] = React.useState(data.dateCarteCommercant);

    const handleData = () => {
        if (!value || value.length == 0 || !value.replace(/\s/g, '').length) {
            alert('Donnée incorrect.');
            return;
        }

        sendData(value, data.id);
    };

    const handleValue = ({ target: { value } }) => {
        setValue(value);
    };

    return (
        <Grid container direction="row" spacing={1} justify="flex-start" alignItems="flex-start">
            <Grid item>
                <TextField
                    //error={Boolean(data.dateFinAssurance)}
                    value={value}
                    type={data._typeFirst}
                    fullWidth
                    onChange={handleValue}
                    size="small"
                    variant="outlined"
                />
            </Grid>
            <Grid item>
                <Button onClick={handleData} variant="contained" color="primary">
                    Mettre à jour
                </Button>
            </Grid>
        </Grid>
    );
};

export default Field;
